module.exports = __webpack_public_path__ + "media/images/dashed-3fb42e95d827ea7b6a92e28389132512.png";